// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5bdc4611","952":"8f86b011"}[chunkId] + ".chunk.js";
};